export default "__VITE_ASSET__DqwkM79o__"